import React from 'react';
import { TooltipHost, DirectionalHint, ITooltipProps } from '@fluentui/react';
import { useHelp } from '../context/HelpContext';

interface IHelpTooltipProps {
  helpText: string;
  children: React.ReactNode;
  directionalHint?: DirectionalHint;
  /** Extra wrapper style – use when you need to control layout (e.g. flex item) */
  wrapperStyle?: React.CSSProperties;
}

/**
 * Wraps children in a styled TooltipHost when help mode is active.
 * Does NOT modify children's own props – uses a transparent overlay div instead.
 */
export const HelpTooltip: React.FC<IHelpTooltipProps> = ({
  helpText,
  children,
  directionalHint = DirectionalHint.bottomCenter,
  wrapperStyle,
}) => {
  const { helpMode } = useHelp();

  if (!helpMode) return <>{children}</>;

  const tooltipProps: ITooltipProps = {
    onRenderContent: () => (
      <div style={{ maxWidth: 280, padding: '4px 2px', fontSize: 13, lineHeight: 1.5 }}>
        <span style={{
          display: 'inline-block',
          width: 7,
          height: 7,
          borderRadius: '50%',
          backgroundColor: '#0078d4',
          marginRight: 6,
          verticalAlign: 'middle',
        }} />
        {helpText}
      </div>
    ),
  };

  return (
    <TooltipHost
      tooltipProps={tooltipProps}
      directionalHint={directionalHint}
      calloutProps={{
        styles: {
          beakCurtain: { background: '#f0f6ff', border: '1px solid #0078d4' },
          calloutMain: { background: '#f0f6ff', border: '1px solid #0078d4' },
        },
      }}
    >
      <span
        style={{
          display: 'inline-block',
          position: 'relative',
          outline: '2px solid #0078d480',
          outlineOffset: 1,
          borderRadius: 3,
          ...wrapperStyle,
        }}
      >
        {children}
      </span>
    </TooltipHost>
  );
};
